<template>
    <b-modal id="barcode-scanner-modal" title="Barkod Oku" centered size="md" no-close-on-backdrop hide-footer @shown="startScanner" @hidden="stopScanner">
        <div class="text-center">
            <div id="reader" class="rounded overflow-hidden"></div>

            <button v-if="cameras.length > 1" type="button" class="btn btn-light btn-sm mt-2" @click="switchCamera"><i class="fa fa-sync-alt mr-1"></i>Kamerayı Çevir</button>

            <p class="text-muted small mt-2 mb-2">Mühür barkodunu kameraya gösteriniz</p>

            <label class="btn btn-outline-secondary btn-sm">
                <input type="file" accept="image/*" @change="scanFromFile" class="d-none" />
                <i class="fa fa-image mr-1"></i>Galeriden Seç
            </label>

            <b-alert v-if="errorMessage" show variant="danger" class="mt-2 mb-0 small">
                {{ errorMessage }}
            </b-alert>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BAlert } from "bootstrap-vue";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";

export default {
    name: "BarcodeScannerModal",
    components: {
        BModal,
        BAlert,
    },
    data() {
        return {
            html5QrCode: null,
            errorMessage: "",
            isScanning: false,
            cameras: [],
            currentCameraIndex: 0,
        };
    },
    methods: {
        startScanner() {
            this.$nextTick(() => {
                this.errorMessage = "";
                this.initializeScanner();
            });
        },
        initializeScanner() {
            const config = {
                fps: 10,
                qrbox: { width: 280, height: 80 },
                formatsToSupport: [Html5QrcodeSupportedFormats.ITF, Html5QrcodeSupportedFormats.CODABAR, Html5QrcodeSupportedFormats.CODE_128, Html5QrcodeSupportedFormats.CODE_39, Html5QrcodeSupportedFormats.EAN_13, Html5QrcodeSupportedFormats.EAN_8],
            };

            Html5Qrcode.getCameras()
                .then((devices) => {
                    if (!devices || devices.length === 0) {
                        this.errorMessage = "Kamera bulunamadı";
                        return;
                    }

                    this.cameras = devices;

                    const rearIndex = devices.findIndex((d) => d.label.toLowerCase().includes("back") || d.label.toLowerCase().includes("rear"));
                    this.currentCameraIndex = rearIndex !== -1 ? rearIndex : 0;

                    this.html5QrCode = new Html5Qrcode("reader", { verbose: false });

                    return this.html5QrCode.start(this.cameras[this.currentCameraIndex].id, config, this.onScanSuccess, () => {});
                })
                .then(() => {
                    this.isScanning = true;
                })
                .catch((err) => {
                    console.error("Kamera başlatılamadı:", err.message || err);
                    this.errorMessage = "Kamera erişimi sağlanamadı. Lütfen izin veriniz.";
                });
        },
        stopScanner() {
            if (!this.html5QrCode || !this.isScanning) return;

            this.isScanning = false;

            this.html5QrCode
                .stop()
                .then(() => {
                    if (this.html5QrCode) {
                        try {
                            this.html5QrCode.clear();
                        } catch {}
                    }
                })
                .catch(() => {});
        },
        onScanSuccess(decodedText, decodedResult) {
            console.log("Barkod okundu:", decodedText, "Format:", decodedResult?.result?.format?.formatName);
            this.processBarcode(decodedText);
        },
        scanFromFile(event) {
            const file = event.target.files[0];
            if (!file) return;

            const fileScanner = new Html5Qrcode("reader", { verbose: false });

            fileScanner
                .scanFile(file, true)
                .then((decodedText) => {
                    console.log("Dosyadan okundu:", decodedText);
                    this.processBarcode(decodedText);
                })
                .catch(() => {
                    this.errorMessage = "Barkod okunamadı. Lütfen net bir fotoğraf seçiniz.";
                });

            event.target.value = "";
        },
        processBarcode(decodedText) {
            const cleaned = decodedText.trim();
            const isValid = /^\d{7}$/.test(cleaned);

            if (isValid) {
                this.$emit("code-scanned", cleaned);
                this.$bvModal.hide("barcode-scanner-modal");
            } else {
                this.errorMessage = `Geçersiz format: "${cleaned}". Sadece 7 haneli mühür numarası kabul edilir.`;
            }
        },
        switchCamera() {
            if (this.cameras.length < 2 || !this.html5QrCode) return;

            this.html5QrCode
                .stop()
                .then(() => {
                    this.currentCameraIndex = (this.currentCameraIndex + 1) % this.cameras.length;

                    const config = {
                        fps: 10,
                        qrbox: { width: 280, height: 80 },
                        formatsToSupport: [Html5QrcodeSupportedFormats.ITF, Html5QrcodeSupportedFormats.CODABAR, Html5QrcodeSupportedFormats.CODE_128, Html5QrcodeSupportedFormats.CODE_39, Html5QrcodeSupportedFormats.EAN_13, Html5QrcodeSupportedFormats.EAN_8],
                    };

                    return this.html5QrCode.start(this.cameras[this.currentCameraIndex].id, config, this.onScanSuccess, () => {});
                })
                .catch(() => {
                    this.errorMessage = "Kamera değiştirilemedi";
                });
        },
    },
    beforeDestroy() {
        this.stopScanner();
    },
};
</script>

<style scoped>
#reader {
    min-height: 220px;
}
</style>
